<script lang="ts" setup>
import items from './help.json';

const preferenceStore = usePreferenceStore();

useSeoMeta({
  title: 'Help'
});

const phone = preferenceStore.preference.company.phone;
const email = 'support@foodinn.ie';
</script>

<template>
  <UContainer class="help min-h-svh">
    <!-- SEO Headings -->
    <h1 v-show="false">Help</h1>

    <UCard
      class="my-4"
      :ui="{ header: { base: 'bg-card-contrast rounded-t-lg' } }"
    >
      <template #header>
        <h2 class="text-2xl font-semibold">
          Contact Our Customer Service
        </h2>
      </template>

      <div class="flex flex-col gap-4">
        <div class="flex gap-1 items-center">
          <UIcon
            class="text-xl"
            name="ic:round-local-phone"
          />
          <h3>Call us for order issue:</h3>
          <h4>
            <a
              class="subtext-card"
              :href="`tel:${phone}`"
            >
              {{ phone }}
            </a>
          </h4>
        </div>

        <div class="flex gap-1 items-center">
          <UIcon
            class="text-xl"
            name="ic:round-mail"
          />
          <h3>For refund emails us:</h3>
          <h4>
            <a
              class="subtext-card"
              :href="`mailto:${email}`"
            >
              {{ email }}
            </a>
          </h4>
        </div>
      </div>
    </UCard>

    <UCard
      class="my-4"
      :ui="{ header: { base: 'bg-card-contrast rounded-t-lg' } }"
    >
      <template #header>
        <h3 class="text-2xl font-semibold">
          Frequently Asked Questions
        </h3>
      </template>

      <UAccordion
        :items="items"
        class="border-b border-card"
        :ui="{ item: { color: 'text-inherit' } }"
      >
        <template #default="{ item, open }">
          <UButton
            variant="ghost"
            class="border-b border-card text-left text-inherit"
            :ui="{ rounded: 'rounded-none', padding: { sm: 'p-3' } }"
          >
            <h3 class="flex-1 text-2xl">{{ item.label }}</h3>

            <template #trailing>
              <UIcon
                class="min-w-4 min-h-5 transform transition-transform duration-200"
                name="ic:round-chevron-right"
                :class="[open && 'rotate-90']"
              />
            </template>
          </UButton>
        </template>

        <template #item="{ item }">
          <div class="px-3 pt-10 pb-7 whitespace-pre-wrap text-sm leading-7">
            <h4>
              <p>{{ item.content }}</p>
            </h4>
          </div>
        </template>
      </UAccordion>
    </UCard>
  </UContainer>
</template>

<style lang="scss" scoped>
.help {
  padding-top: var(--header-height);
}
</style>
